export default __webpack_public_path__ + "static/media/gasTanksSlider.cdce2a04.jpg";